export const countries = [
  { id: "AF", name: "Afghanistan", nameFr: "Afghanistan" },
  { id: "ZA", name: "South Africa", nameFr: "Afrique du Sud" },
  { id: "AL", name: "Albania", nameFr: "Albanie" },
  { id: "DZ", name: "Algeria", nameFr: "Algérie" },
  { id: "DE", name: "Germany", nameFr: "Allemagne" },
  { id: "AD", name: "Andorra", nameFr: "Andorre" },
  { id: "AO", name: "Angola", nameFr: "Angola" },
  { id: "SA", name: "Saudi Arabia", nameFr: "Arabie Saoudite" },
  { id: "AR", name: "Argentina", nameFr: "Argentine" },
  { id: "AM", name: "Armenia", nameFr: "Arménie" },
  { id: "AU", name: "Australia", nameFr: "Australie" },
  { id: "AT", name: "Austria", nameFr: "Autriche" },
  { id: "AZ", name: "Azerbaijan", nameFr: "Azerbaïdjan" },
  { id: "BS", name: "Bahamas", nameFr: "Bahamas" },
  { id: "BH", name: "Bahrain", nameFr: "Bahreïn" },
  { id: "BD", name: "Bangladesh", nameFr: "Bangladesh" },
  { id: "BB", name: "Barbados", nameFr: "Barbade" },
  { id: "BE", name: "Belgium", nameFr: "Belgique" },
  { id: "BZ", name: "Belize", nameFr: "Belize" },
  { id: "BJ", name: "Benin", nameFr: "Bénin" },
  { id: "BT", name: "Bhutan", nameFr: "Bhoutan" },
  { id: "BY", name: "Belarus", nameFr: "Biélorussie" },
  { id: "MM", name: "Myanmar", nameFr: "Birmanie" },
  { id: "BO", name: "Bolivia", nameFr: "Bolivie" },
  { id: "BA", name: "Bosnia and Herzegovina", nameFr: "Bosnie-Herzégovine" },
  { id: "BW", name: "Botswana", nameFr: "Botswana" },
  { id: "BR", name: "Brazil", nameFr: "Brésil" },
  { id: "BN", name: "Brunei", nameFr: "Brunei" },
  { id: "BG", name: "Bulgaria", nameFr: "Bulgarie" },
  { id: "BF", name: "Burkina Faso", nameFr: "Burkina Faso" },
  { id: "BI", name: "Burundi", nameFr: "Burundi" },
  { id: "KH", name: "Cambodia", nameFr: "Cambodge" },
  { id: "CM", name: "Cameroon", nameFr: "Cameroun" },
  { id: "CA", name: "Canada", nameFr: "Canada" },
  { id: "CV", name: "Cape Verde", nameFr: "Cap-Vert" },
  {
    id: "CF",
    name: "Central African Republic",
    nameFr: "République Centrafricaine",
  },
  { id: "CL", name: "Chile", nameFr: "Chili" },
  { id: "CN", name: "China", nameFr: "Chine" },
  { id: "CY", name: "Cyprus", nameFr: "Chypre" },
  { id: "CO", name: "Colombia", nameFr: "Colombie" },
  { id: "KM", name: "Comoros", nameFr: "Comores" },
  { id: "CG", name: "Congo", nameFr: "Congo" },
  {
    id: "CD",
    name: "Democratic Republic of the Congo",
    nameFr: "République Démocratique du Congo",
  },
  { id: "KP", name: "North Korea", nameFr: "Corée du Nord" },
  { id: "KR", name: "South Korea", nameFr: "Corée du Sud" },
  { id: "CR", name: "Costa Rica", nameFr: "Costa Rica" },
  { id: "CI", name: "Ivory Coast", nameFr: "Côte d'Ivoire" },
  { id: "HR", name: "Croatia", nameFr: "Croatie" },
  { id: "CU", name: "Cuba", nameFr: "Cuba" },
  { id: "DK", name: "Denmark", nameFr: "Danemark" },
  { id: "DJ", name: "Djibouti", nameFr: "Djibouti" },
  { id: "DM", name: "Dominica", nameFr: "Dominique" },
  { id: "EG", name: "Egypt", nameFr: "Égypte" },
  { id: "AE", name: "United Arab Emirates", nameFr: "Émirats Arabes Unis" },
  { id: "EC", name: "Ecuador", nameFr: "Équateur" },
  { id: "ER", name: "Eritrea", nameFr: "Érythrée" },
  { id: "ES", name: "Spain", nameFr: "Espagne" },
  { id: "EE", name: "Estonia", nameFr: "Estonie" },
  { id: "US", name: "United States", nameFr: "États-Unis" },
  { id: "ET", name: "Ethiopia", nameFr: "Éthiopie" },
  { id: "FJ", name: "Fiji", nameFr: "Fidji" },
  { id: "FI", name: "Finland", nameFr: "Finlande" },
  { id: "FR", name: "France", nameFr: "France" },
  { id: "GA", name: "Gabon", nameFr: "Gabon" },
  { id: "GM", name: "Gambia", nameFr: "Gambie" },
  { id: "GE", name: "Georgia", nameFr: "Géorgie" },
  { id: "GH", name: "Ghana", nameFr: "Ghana" },
  { id: "GR", name: "Greece", nameFr: "Grèce" },
  { id: "GD", name: "Grenada", nameFr: "Grenade" },
  { id: "GT", name: "Guatemala", nameFr: "Guatemala" },
  { id: "GN", name: "Guinea", nameFr: "Guinée" },
  { id: "GQ", name: "Equatorial Guinea", nameFr: "Guinée Équatoriale" },
  { id: "GW", name: "Guinea-Bissau", nameFr: "Guinée-Bissau" },
  { id: "GY", name: "Guyana", nameFr: "Guyana" },
  { id: "HT", name: "Haiti", nameFr: "Haïti" },
  { id: "HN", name: "Honduras", nameFr: "Honduras" },
  { id: "HU", name: "Hungary", nameFr: "Hongrie" },
  { id: "IN", name: "India", nameFr: "Inde" },
  { id: "ID", name: "Indonesia", nameFr: "Indonésie" },
  { id: "IQ", name: "Iraq", nameFr: "Irak" },
  { id: "IR", name: "Iran", nameFr: "Iran" },
  { id: "IE", name: "Ireland", nameFr: "Irlande" },
  { id: "IS", name: "Iceland", nameFr: "Islande" },
  { id: "IL", name: "Israel", nameFr: "Israël" },
  { id: "IT", name: "Italy", nameFr: "Italie" },
  { id: "JM", name: "Jamaica", nameFr: "Jamaïque" },
  { id: "JP", name: "Japan", nameFr: "Japon" },
  { id: "JO", name: "Jordan", nameFr: "Jordanie" },
  { id: "KZ", name: "Kazakhstan", nameFr: "Kazakhstan" },
  { id: "KE", name: "Kenya", nameFr: "Kenya" },
  { id: "KG", name: "Kyrgyzstan", nameFr: "Kirghizistan" },
  { id: "KI", name: "Kiribati", nameFr: "Kiribati" },
  { id: "KW", name: "Kuwait", nameFr: "Koweït" },
  { id: "LA", name: "Laos", nameFr: "Laos" },
  { id: "LS", name: "Lesotho", nameFr: "Lesotho" },
  { id: "LV", name: "Latvia", nameFr: "Lettonie" },
  { id: "LB", name: "Lebanon", nameFr: "Liban" },
  { id: "LR", name: "Liberia", nameFr: "Libéria" },
  { id: "LY", name: "Libya", nameFr: "Libye" },
  { id: "LI", name: "Liechtenstein", nameFr: "Liechtenstein" },
  { id: "LT", name: "Lithuania", nameFr: "Lituanie" },
  { id: "LU", name: "Luxembourg", nameFr: "Luxembourg" },
  { id: "MK", name: "North Macedonia", nameFr: "Macédoine du Nord" },
  { id: "MG", name: "Madagascar", nameFr: "Madagascar" },
  { id: "MY", name: "Malaysia", nameFr: "Malaisie" },
  { id: "MW", name: "Malawi", nameFr: "Malawi" },
  { id: "MV", name: "Maldives", nameFr: "Maldives" },
  { id: "ML", name: "Mali", nameFr: "Mali" },
  { id: "MT", name: "Malta", nameFr: "Malte" },
  { id: "MA", name: "Morocco", nameFr: "Maroc" },
  { id: "MH", name: "Marshall Islands", nameFr: "Îles Marshall" },
  { id: "MU", name: "Mauritius", nameFr: "Maurice" },
  { id: "MR", name: "Mauritania", nameFr: "Mauritanie" },
  { id: "MX", name: "Mexico", nameFr: "Mexique" },
  { id: "FM", name: "Micronesia", nameFr: "Micronésie" },
  { id: "MD", name: "Moldova", nameFr: "Moldavie" },
  { id: "MC", name: "Monaco", nameFr: "Monaco" },
  { id: "MN", name: "Mongolia", nameFr: "Mongolie" },
  { id: "ME", name: "Montenegro", nameFr: "Monténégro" },
  { id: "MZ", name: "Mozambique", nameFr: "Mozambique" },
  { id: "NA", name: "Namibia", nameFr: "Namibie" },
  { id: "NR", name: "Nauru", nameFr: "Nauru" },
  { id: "NP", name: "Nepal", nameFr: "Népal" },
  { id: "NI", name: "Nicaragua", nameFr: "Nicaragua" },
  { id: "NE", name: "Niger", nameFr: "Niger" },
  { id: "NG", name: "Nigeria", nameFr: "Nigeria" },
  { id: "NO", name: "Norway", nameFr: "Norvège" },
  { id: "NZ", name: "New Zealand", nameFr: "Nouvelle-Zélande" },
  { id: "OM", name: "Oman", nameFr: "Oman" },
  { id: "UG", name: "Uganda", nameFr: "Ouganda" },
  { id: "UZ", name: "Uzbekistan", nameFr: "Ouzbékistan" },
  { id: "PK", name: "Pakistan", nameFr: "Pakistan" },
  { id: "PW", name: "Palau", nameFr: "Palaos" },
  { id: "PA", name: "Panama", nameFr: "Panama" },
  { id: "PG", name: "Papua New Guinea", nameFr: "Papouasie-Nouvelle-Guinée" },
  { id: "PY", name: "Paraguay", nameFr: "Paraguay" },
  { id: "NL", name: "Netherlands", nameFr: "Pays-Bas" },
  { id: "PE", name: "Peru", nameFr: "Pérou" },
  { id: "PH", name: "Philippines", nameFr: "Philippines" },
  { id: "PL", name: "Poland", nameFr: "Pologne" },
  { id: "PT", name: "Portugal", nameFr: "Portugal" },
  { id: "QA", name: "Qatar", nameFr: "Qatar" },
  { id: "RO", name: "Romania", nameFr: "Roumanie" },
  { id: "GB", name: "United Kingdom", nameFr: "Royaume-Uni" },
  { id: "RU", name: "Russia", nameFr: "Russie" },
  { id: "RW", name: "Rwanda", nameFr: "Rwanda" },
  { id: "KN", name: "Saint Kitts and Nevis", nameFr: "Saint-Kitts-et-Nevis" },
  { id: "SM", name: "San Marino", nameFr: "Saint-Marin" },
  {
    id: "VC",
    name: "Saint Vincent and the Grenadines",
    nameFr: "Saint-Vincent-et-les-Grenadines",
  },
  { id: "LC", name: "Saint Lucia", nameFr: "Sainte-Lucie" },
  { id: "SB", name: "Solomon Islands", nameFr: "Îles Salomon" },
  { id: "SV", name: "El Salvador", nameFr: "Salvador" },
  { id: "WS", name: "Samoa", nameFr: "Samoa" },
  { id: "ST", name: "Sao Tome and Principe", nameFr: "Sao Tomé-et-Principe" },
  { id: "SN", name: "Senegal", nameFr: "Sénégal" },
  { id: "RS", name: "Serbia", nameFr: "Serbie" },
  { id: "SC", name: "Seychelles", nameFr: "Seychelles" },
  { id: "SL", name: "Sierra Leone", nameFr: "Sierra Leone" },
  { id: "SG", name: "Singapore", nameFr: "Singapour" },
  { id: "SK", name: "Slovakia", nameFr: "Slovaquie" },
  { id: "SI", name: "Slovenia", nameFr: "Slovénie" },
  { id: "SO", name: "Somalia", nameFr: "Somalie" },
  { id: "SD", name: "Sudan", nameFr: "Soudan" },
  { id: "SS", name: "South Sudan", nameFr: "Soudan du Sud" },
  { id: "LK", name: "Sri Lanka", nameFr: "Sri Lanka" },
  { id: "SE", name: "Sweden", nameFr: "Suède" },
  { id: "CH", name: "Switzerland", nameFr: "Suisse" },
  { id: "SR", name: "Suriname", nameFr: "Suriname" },
  { id: "SZ", name: "Eswatini", nameFr: "Eswatini" },
  { id: "SY", name: "Syria", nameFr: "Syrie" },
  { id: "TJ", name: "Tajikistan", nameFr: "Tadjikistan" },
  { id: "TZ", name: "Tanzania", nameFr: "Tanzanie" },
  { id: "TD", name: "Chad", nameFr: "Tchad" },
  { id: "CZ", name: "Czech Republic", nameFr: "République Tchèque" },
  { id: "TH", name: "Thailand", nameFr: "Thaïlande" },
  { id: "TL", name: "Timor-Leste", nameFr: "Timor-Leste" },
  { id: "TG", name: "Togo", nameFr: "Togo" },
  { id: "TO", name: "Tonga", nameFr: "Tonga" },
  { id: "TT", name: "Trinidad and Tobago", nameFr: "Trinité-et-Tobago" },
  { id: "TN", name: "Tunisia", nameFr: "Tunisie" },
  { id: "TM", name: "Turkmenistan", nameFr: "Turkménistan" },
  { id: "TR", name: "Turkey", nameFr: "Turquie" },
  { id: "TV", name: "Tuvalu", nameFr: "Tuvalu" },
  { id: "UA", name: "Ukraine", nameFr: "Ukraine" },
  { id: "UY", name: "Uruguay", nameFr: "Uruguay" },
  { id: "VU", name: "Vanuatu", nameFr: "Vanuatu" },
  { id: "VA", name: "Vatican City", nameFr: "Vatican" },
  { id: "VE", name: "Venezuela", nameFr: "Venezuela" },
  { id: "VN", name: "Vietnam", nameFr: "Vietnam" },
  { id: "YE", name: "Yemen", nameFr: "Yémen" },
  { id: "ZM", name: "Zambia", nameFr: "Zambie" },
  { id: "ZW", name: "Zimbabwe", nameFr: "Zimbabwe" },
];
